import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-document-type-chip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './document-type-chip.component.html',
  styleUrls: ['./document-type-chip.component.scss'],
})
export class DocumentTypeChipComponent {
  @Input({ required: true }) label = '';
  @Input() active = false;
  @Input() count?: number;
  /** When > 0, count renders as selected/total (picker selection mode). */
  @Input() selectedCount?: number;
  @Input() color?: string;
  @Input() size: 'default' | 'compact' = 'default';

  readonly toggle = output<void>();

  get hasSelection(): boolean {
    return (this.selectedCount ?? 0) > 0;
  }

  get countLabel(): string | null {
    if (this.count == null) return null;
    if (this.hasSelection) return `${this.selectedCount}/${this.count}`;
    return `(${this.count})`;
  }
}
